import { ItemDetailRecord } from '../types/inventoryItem';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const itemDetailQueryAtom = createQueryAtomFactory(
  'settings.itemDetail',
  (params: { ids: string[] }) => ({
    items: {
      __args: {
        filter: {
          ids: params.ids,
        },
        pagination: {
          limit: 1,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
        skuNumber: true,
        description: true,
        notes: true,
        category: {
          id: true,
          name: true,
        },
        itemGroup: {
          id: true,
          name: true,
        },
        pricingUnitOverride: true,
        effectivePricingUnit: true,
        attributeValues: true,
        customAttributes: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data): ItemDetailRecord | null => {
      const item = data?.items?.entries?.[0];
      if (!item) {
        return null;
      }

      return {
        id: item.id,
        name: item.name,
        skuNumber: item.skuNumber,
        description: item.description ?? '',
        notes: item.notes ?? '',
        category: item.category
          ? {
              id: item.category.id,
              name: item.category.name,
            }
          : null,
        itemGroup: item.itemGroup
          ? {
              id: item.itemGroup.id,
              name: item.itemGroup.name,
            }
          : null,
        pricingUnitOverride: item.pricingUnitOverride ?? null,
        effectivePricingUnit: item.effectivePricingUnit,
        attributeValues: item.attributeValues ?? {},
        customAttributes: item.customAttributes ?? null,
        timestamps: {
          createdAt: parseZonedDateTime(item.timestamps.createdAt),
          updatedAt: parseZonedDateTime(item.timestamps.updatedAt),
        },
      };
    },
  },
);
